import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "marketing-your-plugin"
    }}>{`Marketing Your Plugin`}</h1>
    <p>{`The Adobe Creative Cloud Developer Brand Guide provides an overview of Adobe brand assets that may be used to market developer integrations. They are your guide for proper usage of Adobe branding and product names within and/or in conjunction with your products and marketing efforts.`}</p>
    <p>{`Use of Adobe assets shown in the Adobe Creative Cloud Developer Brand Guide are subject to the Adobe Developer Terms (incorporated in the Adobe General Terms of Use for Adobe.com) and any additional, applicable license agreement between you and Adobe. The Adobe Developer Terms of Use contain a license only for the assets displayed and whose usage is described in the Adobe Creative Cloud Developer Brand Guide. You are not authorized under those Terms to use the Adobe corporate logo or any other Adobe logo, icon, font, image, or other Adobe content not shown in the Adobe Creative Cloud Developer Brand Guidelines. Please also refer to the company's general Usage Guidelines for Adobe trademarks, images, product icons, and logos at `}<a parentName="p" {...{
        "href": "https://www.adobe.com/legal/permissions.html"
      }}>{`https://www.adobe.com/legal/permissions.html`}</a>{`.`}</p>
    <p>{`The Adobe Creative Cloud Developer Brand Guide is undergoing a refresh with new badges to help you indicate which Adobe Creative Cloud apps your plugin, extension, or integration is compatible with. Downloads to the new guide and the badges will be available from this page shortly.`}</p>
    <p><strong parentName="p">{`Coming soon`}</strong></p>
    <ul>
      <li parentName="ul">{`New Adobe Creative Cloud Developer Brand Guide`}</li>
      <li parentName="ul">{`“Designed for” Adobe product badges:`}
        <ul parentName="li">
          <li parentName="ul">{`Adobe XD`}</li>
          <li parentName="ul">{`Adobe Photoshop`}</li>
          <li parentName="ul">{`Adobe Illustrator`}</li>
          <li parentName="ul">{`Adobe InDesign`}</li>
          <li parentName="ul">{`Adobe Premiere Pro`}</li>
          <li parentName="ul">{`Adobe After Effects`}</li>
          <li parentName="ul">{`And more!`}</li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      